import { BasePage } from '@/components/ui/base-page'

export function AnnouncementsPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-8">Investment Announcements</h2>
      <p className="text-lg mb-6">Latest announcements, updates, and news about our investment activities and portfolios.</p>

      {/* You can filter articles from the main BlogPage component based on category === 'Investment Announcements' */}
      <div className="bg-green-50 p-4 rounded-lg">
        <p className="text-sm">Coming soon: List of investment announcement articles will be displayed here.</p>
      </div>
    </div>
  )
}